<template>
  <div class="player">
    <uep-editor-player :url="$route.params.id" :query="$route.query">
    </uep-editor-player>
  </div>
</template>

<script>
  export default {
    name: 'player'
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .player {
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// demo/components/UepEditorPlayer.vue